import { useState } from "react";
import { suggestEmail } from "@/features/quote/shared/email-suggestion";
import { fieldBaseClass, labelClass } from "@/shared/ui/form/field-styles";
import { PhoneInput } from "@/shared/ui/PhoneInput";

/** Email + phone in a 2-column grid - shared between QuoteWizard's privat and erhverv contact steps. Error strings are controlled by the caller. */
export function ContactFields({
  email,
  phone,
  onEmailChange,
  onEmailBlur,
  onPhoneChange,
  onPhoneBlur,
  emailError,
  phoneError,
}: {
  email: string;
  phone: string;
  onEmailChange: (value: string) => void;
  onEmailBlur: (value: string) => void;
  onPhoneChange: (value: string) => void;
  onPhoneBlur: () => void;
  emailError?: string;
  phoneError?: string;
}) {
  const [emailSuggestion, setEmailSuggestion] = useState<string | null>(null);
  const changeEmail = (value: string) => {
    setEmailSuggestion(null);
    onEmailChange(value);
  };
  return (
    <div className="mb-5 grid grid-cols-1 gap-3.5 sm:grid-cols-2">
      <div>
        <label htmlFor="wiz-email" className={labelClass}>
          E-mail
        </label>
        <input
          id="wiz-email"
          type="email"
          autoComplete="email"
          placeholder="navn@eksempel.dk"
          value={email}
          onChange={(e) => changeEmail(e.target.value)}
          onBlur={(e) => {
            onEmailBlur(e.target.value);
            setEmailSuggestion(suggestEmail(e.target.value));
          }}
          className={`${fieldBaseClass} ${emailError ? "border-error focus:border-error" : ""}`}
        />
        {emailError && <p className="mt-1 text-sm text-error">{emailError}</p>}
        {emailSuggestion && !emailError ? (
          <p className="mt-1 text-sm text-ink-muted">
            Mente du{" "}
            <button
              type="button"
              onClick={() => changeEmail(emailSuggestion)}
              className="text-link underline underline-offset-2 hover:text-ink"
            >
              {emailSuggestion}
            </button>
            ?
          </p>
        ) : null}
      </div>
      <div>
        <label htmlFor="wiz-phone" className={labelClass}>
          Telefonnummer
        </label>
        <PhoneInput
          id="wiz-phone"
          value={phone}
          onChange={onPhoneChange}
          onBlur={onPhoneBlur}
          error={!!phoneError}
          className="focus-ring-within rounded border border-border bg-white"
          inputClassName="px-3.5 py-3 text-[15px] text-ink placeholder:text-ink-subtle"
        />
        {phoneError && <p className="mt-1 text-sm text-error">{phoneError}</p>}
      </div>
    </div>
  );
}
